import { ElementRef } from '@angular/core';
import { BOOKER_CONFIG } from '@shared/booker';
// TODO: investigate optimized approach
/**
 * Function that focus to the first field with an error
 * @param {ElementRef} element form element
 * @param {ElementRef} selector selector target
 * @returns {void}
 */
export function focusOnErrorField(
  element: ElementRef,
  selector = `.${BOOKER_CONFIG.INVALID_CONTROL_CLASS}`,
): void {
  const el = element.nativeElement.querySelector(selector);

  if (el.nodeName === 'INPUT') {
    requestAnimationFrame(() => {
      element.nativeElement.querySelector(selector)?.focus();
    });
  } else {
    element.nativeElement.querySelector(selector).click();
  }
}
